module.exports = __webpack_public_path__ + "img/232-complated.2dc9ce93.png";